import { RowComponentProps } from "react-window";

import { css } from "@emotion/react";

import { Filter } from "shared/types/interfaces";

import ListCompany from "./ListCompany";

const RowComponent = ({
    index,
    query,
    companies,
    style,
    sendToQueryParams
}: RowComponentProps<{
    query: string;
    companies: any;
    sendToQueryParams: (newCompany: Filter) => void;
}>) => {
    return (
        <ul
            css={css({
                ...style
            })}
        >
            <ListCompany
                data={companies[index]}
                query={query}
                selectCompany={sendToQueryParams}
            />
        </ul>
    );
};

export default RowComponent;
